// extracted by mini-css-extract-plugin
module.exports = {"alphabetContainer":"BrandsAlphabet_alphabetContainer__mdm_E","leter":"BrandsAlphabet_leter__BtfK9","letterSymbols":"BrandsAlphabet_letterSymbols__LttIo"};